import { useReducer } from 'react'

import {
  type UseControls,
  type UseControlsActions,
  UseControlsActionTypes,
  type UseControlsReducerState,
} from '../types'

const initialState: UseControlsReducerState = {
  isSeoMetaTags: true,
  isWireframeTypes: true,
  isNotes: true,
  isCommaSeparated: false,
  isHeadersSet: true,
  isLinks: false,
}

const reducer = (
  state: UseControlsReducerState,
  action: UseControlsActions
): UseControlsReducerState => {
  switch (action.type) {
    case UseControlsActionTypes.SET_WIREFRAMES:
      return {
        ...state,
        isWireframeTypes: !state.isWireframeTypes,
      }

    case UseControlsActionTypes.SET_SEO_META:
      return {
        ...state,
        isSeoMetaTags: !state.isSeoMetaTags,
      }

    case UseControlsActionTypes.SET_NOTES:
      return {
        ...state,
        isNotes: !state.isNotes,
      }

    case UseControlsActionTypes.SET_HEADERS:
      return {
        ...state,
        isHeadersSet: !state.isHeadersSet,
      }

    case UseControlsActionTypes.SET_LINK:
      return {
        ...state,
        isLinks: !state.isLinks,
      }

    case UseControlsActionTypes.SET_COMMA_SEPARATOR:
      return {
        ...state,
        isCommaSeparated: !state.isCommaSeparated,
      }

    default:
      return state
  }
}

const useControls = (): UseControls => {
  const [state, dispatch] = useReducer(reducer, { ...initialState })

  return {
    state,
    actions: {
      setWireframes: () =>
        dispatch({ type: UseControlsActionTypes.SET_WIREFRAMES }),
      setSeoMeta: () => dispatch({ type: UseControlsActionTypes.SET_SEO_META }),
      setNotes: () => dispatch({ type: UseControlsActionTypes.SET_NOTES }),
      setHeaders: () => dispatch({ type: UseControlsActionTypes.SET_HEADERS }),
      setLinks: () => dispatch({ type: UseControlsActionTypes.SET_LINK }),
      setCommaSeparator: () =>
        dispatch({ type: UseControlsActionTypes.SET_COMMA_SEPARATOR }),
    },
  }
}

export default useControls
